import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Typography, Divider, LinearProgress } from "@material-ui/core";
import EnableFeatureFlags from "../../../components/Forms/Features/EnableFeatureFlags/index.js";
import { FlagFormContextProvider } from "../../../components/Forms/Features/EnableFeatureFlags/flagformcontextprovider";
import useCurrentFacility from "../../../hooks/useCurrentFacility";
import apiClient from "../../../auth/apiClient";

const GlobalFeatureFlagsPage = () => {
  const isAdmin = useSelector((state) => state?.user?.isAdmin);
  const { facilityID } = useCurrentFacility();
  const [rootEntityId, setRootEntityId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRootEntity = async () => {
      if (!facilityID) {
        setError("No facility selected");
        setLoading(false);
        return;
      }
      try {
        const response = await apiClient.get(`entities/${facilityID}/tree`);
        const root = response.data?.find((e) => e.parententityid === null);
        if (root) {
          setRootEntityId(root.entityid);
        } else {
          setError("Root tenant not found");
        }
      } catch (err) {
        console.error("Failed to fetch root entity", err);
        setError("Failed to load");
      } finally {
        setLoading(false);
      }
    };
    fetchRootEntity();
  }, [facilityID]);

  if (!isAdmin) return <></>;
  if (loading) return <LinearProgress />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!rootEntityId) return <Typography>Unable to load root entity</Typography>;

  return (
    <div style={{ padding: 16 }}>
      <Typography variant="h4">Global Feature Flags</Typography>
      <Divider style={{ marginBottom: 16 }} />
      <FlagFormContextProvider entityId={rootEntityId} showGlobal={true}>
        <EnableFeatureFlags />
      </FlagFormContextProvider>
    </div>
  );
};

export default GlobalFeatureFlagsPage;
